import React from "react";
import "../../Assets/SCSS/components/Label.scss";

const LabelIcon = ({ labelClassNames, img, label, className }) => (
  <div className={`margin-bottom-8 ${className}`}>
    <span className="icon-with-label">
      <img src={img} alt="icon" height="16" style={{ marginRight: 8 }} />
    </span>
    <span className={`${labelClassNames} small-dark-secondary`}>{label}</span>
  </div>
);

export default LabelIcon;
